<main [attr.aria-label]="'content.edit-user-profile' | translate">
  @if (user) {
    <h1 class="content-main-title">{{ 'content.edit-profile' | translate }} - {{ user.userName }}</h1>
  }
  <div class="d-flex justify-content-end">{{ 'content.all.required-field-explanation' | translate }}</div>
  <h1>{{ 'content.user-profile' | translate }}</h1>
  @if (user) {
    <div class="user-profile mb-4">
      <div class="row mb-2">
        <div class="col-md-4">
          <h2>{{ 'content.person.first-name' | translate }}</h2>
          <div class="form-control">{{ user.firstName }}</div>
        </div>
        <div class="col-md-4">
          <h2>{{ 'content.person.middle-name' | translate }}</h2>
          <div class="form-control">{{ user.middleName }}</div>
        </div>
        <div class="col-md-4">
          <h2>{{ 'content.person.last-name' | translate }}</h2>
          <div class="form-control">{{ user.lastName }}</div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-4">
          <h2>{{ 'content.person.email' | translate }}</h2>
          <div class="form-control">{{ user.email }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <h2>{{ 'content.phone.phone' | translate }}</h2>
          <div class="form-control">{{ user.phone }}</div>
        </div>
        <div class="col-md-4">
          <h2>{{ 'content.phone.extension' | translate }}</h2>
          <div class="form-control">{{ user.extension }}</div>
        </div>
      </div>
    </div>
  }

  <h1>{{ 'content.security' | translate }}</h1>
  <h2 class="mt-4">{{ 'content.change-password' | translate }}</h2>
  <div class="mt-2 mb-4">{{ 'content.changing-your-password-log-in-again' | translate }}</div>
  <app-reset-password mode="normal" [saveEnabled]="saveEnabled" (passwordChanged)="onPasswordChanged($event)"></app-reset-password>

  <h2 class="mt-4">{{ 'content.mfa' | translate }}</h2>
  @if (numMfaDevices === 0) {
    <div class="mb-2">{{ 'content.please-add-mfa-device-or-required-next-login' | translate }}</div>
  }
  <div class="d-flex justify-content-start">
    <div class="mfa-admin">
      @if (user) {
        <app-mfa-user-device-admin [userName]="user.userName" (mfaDevicesChanged)="numMfaDevices = $event"></app-mfa-user-device-admin>
      }
    </div>
  </div>
</main>
